import React from "react";
import { FACILITIES } from "@/lib/content";
import { HeartPulse, ScanFace, ShieldCheck } from "lucide-react";

const ICONS = { HeartPulse, ScanFace, ShieldCheck };

export default function Facilities() {
    return (
        <section
            id="technology"
            data-testid="facilities-section"
            className="py-24 md:py-32 bg-[#faf9f6]"
        >
            <div className="mx-auto max-w-7xl px-6 md:px-12">
                <div className="max-w-3xl mb-14">
                    <div className="text-xs uppercase tracking-[0.3em] text-[#7a8582] flex items-center">
                        <span className="gdc-divider" />
                        Technology &amp; comfort
                    </div>
                    <h2 className="font-serif-display mt-4 text-4xl md:text-5xl leading-tight text-[#1a1d1c]">
                        Modern dentistry that
                        <br />
                        <span className="italic text-[#114b5f]">
                            actually feels calm.
                        </span>
                    </h2>
                    <p className="mt-5 text-[#4a5250] max-w-2xl">
                        Two investments that quietly set us apart from every
                        other clinic in Udaipur — designed to make even the
                        most anxious patient feel completely at ease.
                    </p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    {FACILITIES.map((f) => {
                        const Icon = ICONS[f.icon] || ShieldCheck;
                        return (
                            <article
                                key={f.id}
                                data-testid={`facility-${f.id}`}
                                className="relative overflow-hidden bg-[#114b5f] text-[#faf9f6] rounded-3xl group"
                            >
                                {f.image && (
                                    <div className="relative aspect-[16/10] overflow-hidden">
                                        <img
                                            src={f.image}
                                            alt={f.title}
                                            className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 group-hover:scale-[1.04]"
                                        />
                                        <div className="absolute inset-0 bg-gradient-to-t from-[#114b5f]/90 via-[#114b5f]/25 to-transparent" />
                                        <div className="absolute top-4 left-4 text-[10px] uppercase tracking-[0.3em] text-[#d4af37] bg-[#0d3a4a]/70 backdrop-blur px-3 py-1 rounded-full">
                                            {f.tag}
                                        </div>
                                    </div>
                                )}

                                <div className="relative p-8 md:p-10">
                                    <div className="pointer-events-none absolute -top-14 -right-14 w-48 h-48 rounded-full bg-[#d4af37]/12 blur-3xl transition-all duration-700 group-hover:scale-125" />
                                    <div className="relative flex items-start gap-4">
                                        <div className="h-12 w-12 shrink-0 rounded-2xl bg-[#faf9f6]/10 border border-[#faf9f6]/15 flex items-center justify-center backdrop-blur">
                                            <Icon
                                                size={22}
                                                strokeWidth={1.4}
                                                className="text-[#d4af37]"
                                            />
                                        </div>
                                        <div>
                                            <h3 className="font-serif-display text-2xl md:text-3xl leading-tight">
                                                {f.title}
                                            </h3>
                                            <p className="mt-3 text-[#faf9f6]/80 leading-relaxed">
                                                {f.description}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </article>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}
